import { render, staticRenderFns } from "./ContentionModal.vue?vue&type=template&id=3e4507ca&"
import script from "./ContentionModal.vue?vue&type=script&lang=js&"
export * from "./ContentionModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentionModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports